/** Do not edit this file, it is automatically generated **/
import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import Icon, { IconProps } from "./Icon";

const IconMoreLineComponent: React.FC<PropsWithChildren<IconProps>> & { DataUrl: string; Content: string; } = (props) => {
return (
  <Icon {...props} viewBox="0 0 16 16">
    <><g>
    <g>
        <circle cx="7" cy="2" r="2" />
    </g>
</g>
<g>
    <g>
        <circle cx="7" cy="8" r="2" />
    </g>
</g>
<g>
    <g>
        <circle cx="7" cy="14" r="2" />
    </g>
</g></>
  </Icon>
);
};

IconMoreLineComponent.DataUrl = "data:image/svg+xml;charset=utf-8;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIGhlaWdodD0iMTIiIGZpbGw9IiM2NjYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGc+CiAgICA8Zz4KICAgICAgPGNpcmNsZSBjeD0iNyIgY3k9IjIiIHI9IjIiLz4KICAgICAgPC9nPgogICAgPC9nPgogICAgPGc+CiAgICAgIDxnPgogICAgICAgIDxjaXJjbGUgY3g9IjciIGN5PSI4IiByPSIyIi8+CiAgICAgICAgPC9nPgogICAgICA8L2c+CiAgICAgIDxnPgogICAgICAgIDxnPgogICAgICAgICAgPGNpcmNsZSBjeD0iNyIgY3k9IjE0IiByPSIyIi8+CiAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgICA8L3N2Zz4=";
IconMoreLineComponent.Content = `<svg viewBox="0 0 16 16" height="12" fill="#666" xmlns="http://www.w3.org/2000/svg">
  <g>
    <g>
      <circle cx="7" cy="2" r="2"/>
      </g>
    </g>
    <g>
      <g>
        <circle cx="7" cy="8" r="2"/>
        </g>
      </g>
      <g>
        <g>
          <circle cx="7" cy="14" r="2"/>
          </g>
        </g>
      </svg>`;

const IconMoreLine = styled(IconMoreLineComponent)``;

export default IconMoreLine;
